// Generated by CoffeeScript 2.7.0
import Admin__Dataclip__ResponsesController from './responses.js';

Skylark.App.Controllers.register({Admin__Dataclip__ResponsesController});
